import {
    REQ_NOTIF_LIST, SET_NOTIF_LIST, SET_ERROR_REQ_NOTIF,
    REQ_PAYMENT, SET_PAYMENT_LIST, SET_ERROR_PAYMENT, 
    REQ_DISBURSE, SET_DISBURSE_LIST, SET_ERROR_DISBURSE, 
    REQ_TIPE_PINJAMAN, SET_TIPE_PINJAMAN, SET_ERROR_TIPE_PINJAMAN, REQ_TIPE_JAMINAN, SET_TIPE_JAMINAN, SET_ERROR_TIPE_JAMINAN} from '../../utils/constants/actionTypes'

const initialState = {
    list : [],
    isLoading : false,
    errorMessage : ''
}   

export const notifState = (state = initialState, action) => {
    switch(action.type) {
        case REQ_NOTIF_LIST :
            return {
                ...state,
                isLoading : true
            }
        case SET_NOTIF_LIST :
            return {
                list : action.payload,
                isLoading : false,
                errorMessage : ''
            }
        case SET_ERROR_REQ_NOTIF : 
            return {
                ...state,
                isLoading : false,
                errorMessage : action.payload 
            }
        default :
            return state;
    }
}

export const disburseState = (state = initialState, action) => {
    switch(action.type) {
        case REQ_DISBURSE :
            return {
                ...state,
                isLoading : true
            }
        case SET_DISBURSE_LIST :
            return {
                list : action.payload,
                isLoading : false,
                errorMessage : ''
            }
        case SET_ERROR_DISBURSE : 
            return {
                ...state,
                isLoading : false,
                errorMessage : action.payload 
            }
        default :
            return state;
    }
}


export const paymentState = (state = initialState, action) => {
    switch(action.type) {
        case REQ_PAYMENT :
            return {
                ...state,
                isLoading : true
            }
        case SET_PAYMENT_LIST :
            return {
                list : action.payload,
                isLoading : false,
                errorMessage : ''
            }
        case SET_ERROR_PAYMENT : 
            return {
                ...state,
                isLoading : false,
                errorMessage : action.payload 
            }
        default :
            return state;
    }
}
    


export const tipePinjamanState = (state = initialState, action) => {
    switch(action.type) {
        case REQ_TIPE_PINJAMAN :
            return {
                ...state,
                isLoading : true
            }
        case SET_TIPE_PINJAMAN :
            return {
                list : action.payload,
                isLoading : false,
                errorMessage : ''
            }
        case SET_ERROR_TIPE_PINJAMAN : 
            return {
                ...state,
                isLoading : false,
                errorMessage : action.payload 
            }
        default :
            return state;
    }
}



export const tipeJaminanState = (state = initialState, action) => {
    switch(action.type) {
        case REQ_TIPE_JAMINAN :
            return {
                ...state,
                isLoading : true
            }
        case SET_TIPE_JAMINAN :
            return {
                list : action.payload,
                isLoading : false,
                errorMessage : ''
            }
        case SET_ERROR_TIPE_JAMINAN : 
            return {
                ...state,
                isLoading : false,
                errorMessage : action.payload 
            }
        default :
            return state;
    }
}
